<template>
  <div id="historyview">
    <div class="body-table table-responsive scroll-bar list-files-table list-files-table-favorite table-mb-pd favorite-files">
      <table class="table table-csHistory">
        <thead>
        <tr>
          <th scope="col" class="w-60">社員名</th>
          <th scope="col" class="text-center w-20 mb-w-23">観覧回数</th>
          <th scope="col" class="hidden-mb w-20 text-center">最終観覧日</th>
        </tr>
        </thead>
        <tbody>
        <tr class="tableInfo" v-for="(history,index) in listHistory" v-bind:key="index">
          <td scope="row" class="w-60">
            <div class="tableInfo--box table-name">
              <div class="table-name--box">
                <div class="text-center avt-favorite">
                  <img :src="history.icon_url" alt class="img-preview avt-folder" />
                  <div class="mypage__kindFile mypage__kindFile-list">
                    <div class="mypage__iconList" v-if="isVideoAndImage(history.media_type_id)">
                      <img src="@img/icon/icon-image.svg" alt="" v-if="isImage(history.media_type_id)">
                      <img src="@img/icon/icon-video.svg" alt="" v-if="isVideo(history.media_type_id)">
                    </div>
                  </div>
                </div>
              </div>
              <div class="admin-name flex-wrap">
                <div class="name w-100">{{truncate(history.name,10,'...')}}</div>
                <div class="date">{{dateFormat(history.created_at)}}</div>
              </div>
            </div>
          </td>
          <td class="table-view text-center table-role w-20 mb-w-23">{{formatNumber(history.total)}}回</td>
          <td class="table-lastview hidden-mb table-role w-10 text-center">{{dateFormat(history.last_date)}}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import {mapState} from 'vuex'
import {MEDIA_TYPE} from '../../../utils/constant'
export default {
  name: 'HistoryView',
  data () {
    return {}
  },
  component: {
    'b-table': BTable
  },
  computed: {
    ...mapState({
      listHistory: state => state.employeeMyPage.listHistory
    })
  },
  mounted () {
    this.$store.dispatch('employeeMyPage/getHistory')
  },
  methods: {
    isImage (value) {
      return value === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    isVideoAndImage (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.IMAGE_ROLE_ID || mediaTypeId === MEDIA_TYPE.VIDEO_ROLE_ID
    }
  }
}
</script>
<style scoped lang='scss'>
  @import "@/assets/stylesheet/auth/historyview.scss";
  @import "@/assets/stylesheet/auth/listfile.scss";
  @import '@/assets/stylesheet/user/list_user.scss';
@import '@/assets/stylesheet/admin/vendor.scss';
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
</style>



// WEBPACK FOOTER //
// src/components/Employee/mypage/HistoryView.vue